import { defineMessages } from 'react-intl';

export const ar = defineMessages({
  metaTitle: {
    id: 'seo_phrasebook_meta_title_ar',
  },
  metaDescription: {
    id: 'seo_phrasebook_meta_description_ar',
  },
});

export const da = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_da' },
  metaDescription: { id: 'seo_phrasebook_meta_description_da' },
});

export const de = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_de' },
  metaDescription: { id: 'seo_phrasebook_meta_description_de' },
});

export const el = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_el' },
  metaDescription: { id: 'seo_phrasebook_meta_description_el' },
});

export const en = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_en' },
  metaDescription: { id: 'seo_phrasebook_meta_description_en' },
});

export const en_us = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_en' },
  metaDescription: { id: 'seo_phrasebook_meta_description_en' },
});

export const es = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_es' },
  metaDescription: { id: 'seo_phrasebook_meta_description_es' },
});

export const es_mx = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_es_mx' },
  metaDescription: { id: 'seo_phrasebook_meta_description_es_mx' },
});

export const fa = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_fa' },
  metaDescription: { id: 'seo_phrasebook_meta_description_fa' },
});

export const fr = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_fr' },
  metaDescription: { id: 'seo_phrasebook_meta_description_fr' },
});

export const he = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_he' },
  metaDescription: { id: 'seo_phrasebook_meta_description_he' },
});

export const hi = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_hi' },
  metaDescription: { id: 'seo_phrasebook_meta_description_hi' },
});

export const id = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_id' },
  metaDescription: { id: 'seo_phrasebook_meta_description_id' },
});

export const is = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_is' },
  metaDescription: { id: 'seo_phrasebook_meta_description_is' },
});

export const it = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_it' },
  metaDescription: { id: 'seo_phrasebook_meta_description_it' },
});

export const jp_full = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_jp_full' },
  metaDescription: { id: 'seo_phrasebook_meta_description_jp_full' },
});

export const jp_romaji = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_jp_romaji' },
  metaDescription: { id: 'seo_phrasebook_meta_description_jp_romaji' },
});

export const ko = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_ko' },
  metaDescription: { id: 'seo_phrasebook_meta_description_ko' },
});

export const mn = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_mn' },
  metaDescription: { id: 'seo_phrasebook_meta_description_mn' },
});

export const nl = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_nl' },
  metaDescription: { id: 'seo_phrasebook_meta_description_nl' },
});

export const no = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_no' },
  metaDescription: { id: 'seo_phrasebook_meta_description_no' },
});

export const pl = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_pl' },
  metaDescription: { id: 'seo_phrasebook_meta_description_pl' },
});

export const pt = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_pt' },
  metaDescription: { id: 'seo_phrasebook_meta_description_pt' },
});

export const pt_br = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_pt_br' },
  metaDescription: { id: 'seo_phrasebook_meta_description_pt_br' },
});

export const ru = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_ru' },
  metaDescription: { id: 'seo_phrasebook_meta_description_ru' },
});

export const sl = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_sl' },
  metaDescription: { id: 'seo_phrasebook_meta_description_sl' },
});

export const sv = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_sv' },
  metaDescription: { id: 'seo_phrasebook_meta_description_sv' },
});

export const sw = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_sw' },
  metaDescription: { id: 'seo_phrasebook_meta_description_sw' },
});

export const th = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_th' },
  metaDescription: { id: 'seo_phrasebook_meta_description_th' },
});

export const tr = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_tr' },
  metaDescription: { id: 'seo_phrasebook_meta_description_tr' },
});

export const uk = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_uk' },
  metaDescription: { id: 'seo_phrasebook_meta_description_uk' },
});

export const yo = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_yo' },
  metaDescription: { id: 'seo_phrasebook_meta_description_yo' },
});

export const zh_cn = defineMessages({
  metaTitle: { id: 'seo_phrasebook_meta_title_zh_cn' },
  metaDescription: { id: 'seo_phrasebook_meta_description_zh_cn' },
});
